export default __webpack_public_path__ + "static/media/présentation.707e36bf.mp4";